import { render } from "./SearchIndex.vue?vue&type=template&id=0ff3f0f0"
import script from "./SearchIndex.vue?vue&type=script&lang=js"
export * from "./SearchIndex.vue?vue&type=script&lang=js"

import "./SearchIndex.vue?vue&type=style&index=0&id=0ff3f0f0&lang=css"

import exportComponent from "/private/tmp/claude-501/-Users-andrei-Desktop-EO-LARAVEL/7545e444-cd9b-404a-a970-150d45c9bb29/scratchpad/wt-csf-prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__